import React from 'react';

export default function PhoneIncomingCallIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-phone-incoming-call"><path className="primary" d="M4 2h4a1 1 0 0 1 .98.8l1 5a1 1 0 0 1-.27.9l-2.52 2.52a12.05 12.05 0 0 0 5.59 5.59l2.51-2.52a1 1 0 0 1 .9-.27l5 1c.47.1.81.5.81.98v4a2 2 0 0 1-2 2h-2A16 16 0 0 1 2 6V4c0-1.1.9-2 2-2z"/><path className="secondary" d="M19.3 3.3a1 1 0 0 1 1.4 1.4L16.42 9H19a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V5a1 1 0 0 1 2 0v2.59l4.3-4.3z"/></svg>
    </Tag>
  )
};
